<div class="list surface--2">
  <app-filter *ngIf="filterList.length > 0" (callbackFunction)="filteringList()" [type]="'proData'"
    [filterList]="filterList"></app-filter>
  <app-the-list [clickRow]="true" [type]="'consultant'" [tableList]="tableList" [loading]="loading"
    [listLimit]="loadLength" [list]="allCandidatesList" [selected]="selected" [loadMoreLength]="10"
    (openCandidate)="openCandidate($event)" (loadMore)="loadMore($event)"></app-the-list>
</div>
